import { DepartamentType } from "../../../types/Departament";
import { post } from "../../../utils/axios-config";
import { DEPARTAMENTS } from "../../../utils/constants";

export const createDepartament = async (data: DepartamentType) => await post<DepartamentType, string>(DEPARTAMENTS, data);